import React from "react"
import { useDispatch } from "react-redux"
import { dragEnter, dragLeave } from "actions/applicationActions"

const DraggingStateContainer = ({ children }) => {
  const dispatch = useDispatch()

  const handleDragEnter = () => {
    dispatch(dragEnter())
  }

  const handleDragLeave = () => {
    dispatch(dragLeave())
  }

  return (
    <div
      className="min-vh-100 flex flex-column flex-row-ns"
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
    >
      {children}
    </div>
  )
}

export { DraggingStateContainer }
